import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-659c0448"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "action-type-ops" }
const _hoisted_2 = {
  key: 0,
  class: "dialog-footer"
}

import { ref, watch, computed } from 'vue'
import {
  alarmContactPage,
  alarmStrategyTreelist,
  alarmPushActionAdd,
  alarmPushActionUpdate,
  alarmPushActionDetail,
} from '@/api'
import type { FormInstance } from 'element-plus'
import { CODE_ENUM, PUSH_ACTION_TYPE_ENUM } from '@/common/enum'
import { ElMessage } from 'element-plus'
import i18n from '@/i18n'


export default /*#__PURE__*/_defineComponent({
  __name: 'push-active-modal',
  props: ['visible', 'data', 'view'],
  emits: ['update:visible', 'success'],
  setup(__props, { emit: $emit }) {

const props = __props;

const t = i18n.global.t

const actionTypeOps = [
  {
    value: PUSH_ACTION_TYPE_ENUM.ALARM_ACTION_ALWAYS,
    label: t('W_PUSH.pushOps1'),
  },
  {
    value: PUSH_ACTION_TYPE_ENUM.ALARM_ACTION_INTERVAL_HOUR,

    label: t('W_PUSH.pushOps2'),
  },
  {
    value: PUSH_ACTION_TYPE_ENUM.ALARM_ACTION_INTERVAL_DAY,
    label: t('W_PUSH.pushOps3'),
  },
]




const title = computed(() => {
  if (props.view) {
    return t('W_PUSH.titleView')
  } else if (props.data.pushActionId) {
    return t('W_PUSH.titleEdit')
  } else {
    return t('W_PUSH.titleNew')
  }
})

const modalLoading = ref(false)
watch(
  () => props.visible,
  () => {
    if (props.visible) {
      modalLoading.value = true
      Promise.all([
        queryContactList(),
        queryAlarmlist(),
        queryDetail(),
      ]).finally(() => {
        modalLoading.value = false
      })
    }
  },
  {
    immediate: true,
  }
)

const formData = ref({
  // actionInternal: '',
  // actionType: PUSH_ACTION_TYPE_ENUM.ONCE,
  name: '',
  reachUserIds: [],
  triggerIds: [],
  actionTypeCode: '',
})

const cancel = () => {
  $emit('update:visible', false)
  // formData.value.actionInternal = ''
  formRef.value.resetFields()
}

const rules: any = {
  name: [{ required: true, message: t('W_PUSH.enterMsg') }],
  actionTypeCode: [{ required: true, message: t('W_PUSH.selectMsg') }],
  triggerIds: [
    { required: true, message: t('W_PUSH.selectMsg'), type: 'array' },
  ],
  // actionType: [{ required: true, message: t('W_PUSH.selectMsg') }],
  reachUserIds: [
    { required: true, type: 'array', message: t('W_PUSH.selectMsg') },
  ],
}

// const actionInternalValidate = (rule: any, value: any, callback: any) => {
//   if (!value && formData.value.actionType === PUSH_ACTION_TYPE_ENUM.REPEAT) {
//     callback(t('W_PUSH.selectMsg'))
//   } else {
//     callback()
//   }
// }

const activeTypeChange = (value: any) => {
  formRef.value.validateField('actionInternal')
}

const loading = ref(false)
const formRef: any = ref<FormInstance>()

const queryDetail = async () => {
  const pushActionId = props.data.pushActionId
  if (!pushActionId) {
    return
  }
  const res: any = await alarmPushActionDetail({
    pushActionId,
  })
  if (res?.code === CODE_ENUM.SUCCESS) {
    const { name, reachUserInfos, actionTypeCode, triggerInfos } =
      res.data || {}

    const reachUserIds = (reachUserInfos || []).map((item: any) => {
      return item.reachUserId
    })

    const triggerIds = (triggerInfos || []).map((_: any) => _.id)
    formData.value = {
      name,
      reachUserIds,
      triggerIds,
      actionTypeCode,
    }
  }
}

const handleSubmit = () => {
  formRef.value.validate(async (valid: boolean) => {
    if (valid) {
      loading.value = true
      const pushActionId = props.data.pushActionId || ''
      const fn = pushActionId ? alarmPushActionUpdate : alarmPushActionAdd
      const { name, reachUserIds, triggerIds, actionTypeCode } = formData.value

      const res: any = await fn({
        name,
        reachUserIds,
        triggerIds,
        pushActionId,
        actionTypeCode,
      }).finally(() => {
        loading.value = false
      })
      if (res?.code === CODE_ENUM.SUCCESS) {
        ElMessage({
          message: t('W_PUSH.opSuccess'),
          type: 'success',
        })
        cancel()
        $emit('success')
      }
    }
  })
}

const contactList: any = ref([])
const queryContactList = async () => {
  const res: any = await alarmContactPage({
    pageSize: 9999,
    curPage: 1,
  })
  contactList.value = (res?.data?.records || []).map(
    ({ name, reachUserId }: any) => {
      return {
        value: reachUserId,
        label: name,
      }
    }
  )
}

const alarmList: any = ref([])
const queryAlarmlist = async () => {
  const res: any = await alarmStrategyTreelist()
  alarmList.value = (res?.data || []).map(({ name, id }: any) => {
    return {
      value: id,
      label: name,
    }
  })
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    class: "dialog",
    width: "480",
    "model-value": props.visible,
    title: _unref(title),
    "before-close": cancel
  }, {
    footer: _withCtx(() => [
      (!props.view)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
            _createVNode(_component_el_button, {
              plain: "",
              onClick: cancel
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('W_PUSH.btnCancel')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              onClick: handleSubmit,
              loading: loading.value,
              type: "primary"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('W_PUSH.btnSave')), 1)
              ]),
              _: 1
            }, 8, ["loading"])
          ]))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createBlock(_component_el_form, {
        ref_key: "formRef",
        ref: formRef,
        class: "form",
        model: formData.value,
        rules: rules,
        "label-width": 100
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: _ctx.$t('W_PUSH.labelPushName'),
            prop: "name"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: formData.value.name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.name) = $event)),
                disabled: props.view,
                maxlength: 50
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: _ctx.$t('W_PUSH.labelTriggerId'),
            prop: "triggerIds"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                class: "select",
                modelValue: formData.value.triggerIds,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.triggerIds) = $event)),
                clearable: "",
                disabled: props.view,
                multiple: ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(alarmList.value, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.value,
                      label: item.label,
                      value: item.value
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: _ctx.$t('W_PUSH.labelReachUserIds'),
            prop: "reachUserIds"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                class: "select",
                modelValue: formData.value.reachUserIds,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.reachUserIds) = $event)),
                multiple: "",
                disabled: props.view
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(contactList.value, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.value,
                      label: item.label,
                      value: item.value
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: _ctx.$t('W_PUSH.pushLabel'),
            prop: "actionTypeCode"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_radio_group, {
                modelValue: formData.value.actionTypeCode,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.actionTypeCode) = $event)),
                onChange: activeTypeChange
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(actionTypeOps, (item) => {
                      return _createVNode(_component_el_radio, {
                        key: item.value,
                        label: item.value,
                        size: "large"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.label), 1)
                        ]),
                        _: 2
                      }, 1032, ["label"])
                    }), 64))
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["model"])), [
        [_directive_loading, modalLoading.value]
      ])
    ]),
    _: 1
  }, 8, ["model-value", "title"]))
}
}

})